const sanitizeHtml = require('sanitize-html');

const RICH_TEXT_SANITIZE_OPTIONS = {
  allowedTags: [
    'a',
    'abbr',
    'b',
    'blockquote',
    'br',
    'caption',
    'code',
    'col',
    'colgroup',
    'dd',
    'del',
    'div',
    'dl',
    'dt',
    'em',
    'figcaption',
    'figure',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'iframe',
    'img',
    'li',
    'ol',
    'p',
    'pre',
    's',
    'span',
    'strong',
    'sub',
    'sup',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'u',
    'ul',
  ],
  allowedAttributes: {
    a: ['href', 'name', 'target', 'rel'],
    col: ['span'],
    img: ['src', 'alt', 'title', 'width', 'height'],
    iframe: [
      'src',
      'width',
      'height',
      'title',
      'allow',
      'allowfullscreen',
      'frameborder',
    ],
    ol: ['start', 'type'],
    table: ['border', 'cellpadding', 'cellspacing'],
    td: ['colspan', 'rowspan'],
    th: ['colspan', 'rowspan', 'scope'],
    ul: ['type'],
    '*': ['class'],
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesByTag: {
    iframe: ['https'],
    img: ['http', 'https'],
  },
  allowedIframeHostnames: [
    'www.youtube.com',
    'youtube.com',
    'www.youtube-nocookie.com',
    'player.vimeo.com',
  ],
  transformTags: {
    a: sanitizeHtml.simpleTransform('a', {rel: 'noopener noreferrer'}, true),
  },
};

function sanitizeRichText(html) {
  return sanitizeHtml(html || '', RICH_TEXT_SANITIZE_OPTIONS);
}

function isAllowedUrl(value, allowedSchemes, allowedHostnames) {
  if (typeof value !== 'string' || !value) {
    return false;
  }

  try {
    const url = new URL(value);
    const scheme = url.protocol.slice(0, -1);

    return (
      allowedSchemes.includes(scheme) &&
      (!allowedHostnames || allowedHostnames.includes(url.hostname))
    );
  } catch (error) {
    return false;
  }
}

function sanitizeRichTextContent(content) {
  if (Array.isArray(content)) {
    return content.map(sanitizeRichTextContent);
  }

  if (!content || typeof content !== 'object') {
    return content;
  }

  const node = {...content};

  if (node.type === 'html') {
    node.value = sanitizeRichText(node.value);
  } else if (
    node.type === 'a' &&
    !isAllowedUrl(node.href, ['http', 'https', 'mailto'])
  ) {
    delete node.href;
  } else if (
    node.type === 'img' &&
    !isAllowedUrl(node.src, ['http', 'https'])
  ) {
    delete node.src;
  } else if (
    node.type === 'youtube' &&
    !isAllowedUrl(
      node.src,
      ['https'],
      ['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com'],
    )
  ) {
    delete node.src;
  }

  if (Array.isArray(node.children)) {
    node.children = node.children.map(sanitizeRichTextContent);
  }

  return node;
}

function mapLineBreak(text) {
  return sanitizeRichText((text || '').replace(/\n/g, '<br/>'));
}

function formatCurrencyDisplay(number) {
  try {
    return number.toLocaleString('en-US', 'currency');
  } catch (er) {
    return '-- --';
  }
}

function validateTextLength(spec, text) {
  const safeText = String(text || '');
  let asciiOnly = true;
  for (let i = 0; i < safeText.length; i++) {
    if (safeText.charCodeAt(i) > 127) {
      asciiOnly = false;
      break;
    }
  }

  if (asciiOnly) {
    return (
      spec.ascii.min <= safeText.length && safeText.length <= spec.ascii.max
    );
  }

  return (
    spec.unicode.min <= safeText.length && safeText.length <= spec.unicode.max
  );
}

module.exports = {
  mapLineBreak,
  formatCurrencyDisplay,
  validateTextLength,
  sanitizeRichText,
  sanitizeRichTextContent,
};
